import {
  GET_PRINT_TEMPLATES,
  GET_PRINT_TEMPLATE,
  CREATE_PRINT_TEMPLATE,
  UPDATE_PRINT_TEMPLATE,
  DELETE_PRINT_TEMPLATES,
  GETTING_PRINT_TEMPLATES,
  GETTING_PRINT_TEMPLATE,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE,
  CREATING_PRINT_TEMPLATE,
  UPDATING_PRINT_TEMPLATE,
  DELETING_PRINT_TEMPLATES,
  GETTING_PRINT_TEMPLATE_SUCCEEDED,
  CREATING_PRINT_TEMPLATE_SUCCEEDED,
  UPDATING_PRINT_TEMPLATE_SUCCEEDED,
  DELETING_PRINT_TEMPLATES_SUCCEEDED,
  GETTING_PRINT_TEMPLATES_SUCCEEDED,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_SUCCEEDED,
  GETTING_PRINT_TEMPLATES_FAILED,
  GETTING_PRINT_TEMPLATE_FAILED,
  CREATING_PRINT_TEMPLATE_FAILED,
  UPDATING_PRINT_TEMPLATE_FAILED,
  DELETING_PRINT_TEMPLATES_FAILED,
  SET_COPY_CURRENT_PRINT_TEMPLATE,
  SET_CURRENT_PRINT_TEMPLATE,
  UNSET_CURRENT_PRINT_TEMPLATE,
  CLEAR_PRINT_TEMPLATE_ERROR,
  CLEAR_PRINT_TEMPLATE_STORE,
  PRINT_AUTO_SAVE_TIMER_START,
  PRINT_AUTO_SAVE_TIMER_END,
  GET_PAGINATED_PRINT_TEMPLATES,
  GETTING_PAGINATED_PRINT_TEMPLATES,
  GETTING_PAGINATED_PRINT_TEMPLATES_SUCCEEDED,
  GETTING_PAGINATED_PRINT_TEMPLATES_FAILED,
  GET_PRINT_TAGS,
  GETTING_PRINT_TAGS,
  GETTING_PRINT_TAGS_SUCCEEDED,
  GETTING_PRINT_TAGS_FAILED,
  GET_PRINT_FILE,
  GETTING_PRINT_FILE_SUCCEEDED,
  GETTING_PRINT_FILE_FAILED,
  DOWNLOADED_PRINT_FILE,
  SET_TEST_DOWNLOAD,
  UPDATE_PRINT_FILTERS,
  RESET_PRINT_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import sortBy from 'lodash.sortby';
import { produce } from 'immer';

const deCamelizer = str => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/([0-9]+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
};

const initialState = {
  getting: false,
  gettingPaginated: true,
  creating: false,
  creatingPaginated: false,
  updating: false,
  deleting: false,
  deletingPaginated: false,
  list: [],
  paginatedList: [],
  current: {
    type: 'PDF'
  },
  error: {
    message: null,
    raw: null
  },
  isTemplateSaved: false,
  isTestDownloadError: false,
  shouldAutoSave: false,
  isAutoSaveTimerRunning: false,
  isAutoSaveSuccess: false,
  isTemplateSaving: false,
  filters: {
    searchInput: '',
    displayActive: true,
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    pageNo: 0,
    totalCount: 0,
    filterTypes: [],
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: [],
    filterTags: []
  },
  tagList: [],
  gettingTags: false,
  printFile: {
    getting: false,
    gettingFileSucceeded: false,
    printFileBlob: {},
    isDownloading: false
  }
};

const types = {
  PDF: 'PDF'
};

export default createReducer(initialState, {
  [GET_PRINT_TEMPLATES]: state => {
    return state;
  },
  [GET_PRINT_TEMPLATE]: state => {
    return state;
  },

  [GET_PAGINATED_PRINT_TEMPLATES]: state => {
    return state;
  },

  [CREATE_PRINT_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [UPDATE_PRINT_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [DELETE_PRINT_TEMPLATES]: (state, action) => {
    return state;
  },
  [GETTING_PRINT_TEMPLATES]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_PAGINATED_PRINT_TEMPLATES]: state => {
    state.gettingPaginated = true;
    return state;
  },
  [GETTING_PRINT_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [CREATING_PRINT_TEMPLATE]: state => {
    state.creating = true;
    state.current = {
      ...state.current,
      active: state.current.active === undefined ? true : state.current.active
    };
    return state;
  },
  [UPDATING_PRINT_TEMPLATE]: state => {
    state.updating = true;
    return state;
  },
  [DELETING_PRINT_TEMPLATES]: state => {
    state.deleting = true;
    return state;
  },
  [GETTING_PRINT_TEMPLATE_SUCCEEDED]: (state, action) => {
    const { template, eventMetaData = [] } = action.payload;

    let hydratedEventMetaData = sortBy(
      eventMetaData.map(data => ({
        ...data,
        productName: data.schemaType === 'EVENT'
          ? `Event Product - ${template.productName}`
          : data.schemaType === 'ENRICHMENT' ? `Enrichment Product - ${data.enrichmentProduct}` : data.schemaTypeDisplayName,
        schemaConditionAttributes: data.schemaConditionAttributes.map(a => ({
          key: a.conditionAttribute,
          name:
            !a.displayName || a.displayName === ''
              ? deCamelizer(a.conditionAttribute)
              : a.displayName,
          dataType: a.conditionAttributeType,
          text: `{{${a.conditionAttribute}}}`,
          attributeFieldType: a.attributeFieldType,
          hasNestedDataFrame: a.hasNestedDataFrame,
          metaAttribute: a.metaAttribute,
          description: a.description,
          subAttribute: {
            ...a?.subAttribute,
            attributes:
              a?.subAttribute?.attributes &&
              a.subAttribute['attributes'].map(b => ({
                key: b.conditionAttribute,
                name:
                  !b.displayName || b.displayName === ''
                    ? deCamelizer(b.conditionAttribute)
                    : b.displayName,
                dataType: b.conditionAttributeType,
                text: `{{${b.conditionAttribute}}}`,
                metaAttribute: b.metaAttribute,
                description: b.description
              }))
          }
        }))
      })).filter(data => data.schemaType === 'EVENT' || data.schemaType === 'ENRICHMENT'),
      'name'
    );

    let updatedTemplate = produce(template, templateDraft => {
      templateDraft.eventMetaData = hydratedEventMetaData;
    });

    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...updatedTemplate };
    state.isTestDownloadError = false;
    return state;
  },
  [CREATING_PRINT_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...action.payload };
    state.isAutoSaveSuccess = state.shouldAutoSave ? true : false;
    state.isTemplateSaved = true;
    state.shouldAutoSave = false;
    state.isTemplateSaving = false;
    return state;
  },
  [UPDATING_PRINT_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...action.payload };
    state.isAutoSaveSuccess = state.shouldAutoSave ? true : false;
    state.isTemplateSaved = true;
    state.shouldAutoSave = false;
    state.isTemplateSaving = false;
    return state;
  },
  [DELETING_PRINT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.deletingPaginated = false;
    state.current = action.payload.find(id => id === state.current.id)
      ? {}
      : state.current;
    state.paginatedList = state.paginatedList.map(template => {
      if (template.id === action.payload[0]) {
        template.active = !template.active;
      }
      return template;
    });
    return state;
  },
  [GETTING_PRINT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload.map(template => ({
      ...template,
      displayType: types[template.type]
    }));
    return state;
  },
  [GETTING_PAGINATED_PRINT_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload.map(template => ({
      ...template,
      displayType: types[template.type]
    }));
    return state;
  },
  [GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_SUCCEEDED]: (
    state,
    action
  ) => {
    state.current = {
      ...state.current,
      associatedCampaigns: action.payload.campaignList.find(
        campaign => campaign.uuid === state.current?.uuid
      )
    };
    state.paginatedList = state.paginatedList.map(template => {
      if (template.id === action.payload.id) {
        template.associatedCampaigns = action.payload.campaignList;
      }
      return template;
    });
    return state;
  },
  [GETTING_PRINT_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_PRINT_TEMPLATES_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_PRINT_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATING_PRINT_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaved = false;
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isTemplateSaving = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATING_PRINT_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaved = false;
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isTemplateSaving = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [DELETING_PRINT_TEMPLATES_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },

  [SET_COPY_CURRENT_PRINT_TEMPLATE]: (state, action) => {
    state.current = action.payload;
    return state;
  },

  [SET_CURRENT_PRINT_TEMPLATE]: (state, action) => {
    state.current = {
      ...action.payload,
      jsonContent: !action.payload.jsonContent ? '' : action.payload.jsonContent
    };
    return state;
  },
  [UNSET_CURRENT_PRINT_TEMPLATE]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [CLEAR_PRINT_TEMPLATE_ERROR]: state => {
    state.error = { ...initialState.error };
    return state;
  },
  [CLEAR_PRINT_TEMPLATE_STORE]: state => {
    let updatedState = {
      ...initialState,
    };
    return updatedState;
  },

  [PRINT_AUTO_SAVE_TIMER_START]: state => {
    state.shouldAutoSave = false;
    state.isAutoSaveSuccess = false;
    state.isAutoSaveTimerRunning = true;
    return state;
  },
  [PRINT_AUTO_SAVE_TIMER_END]: state => {
    state.shouldAutoSave = true;
    state.isAutoSaveTimerRunning = false;
    return state;
  },

  [GET_PRINT_TAGS]: state => {
    state.error = {};
    return state;
  },

  [GETTING_PRINT_TAGS]: state => {
    state.gettingTags = true;
    return state;
  },

  [GETTING_PRINT_TAGS_SUCCEEDED]: (state, action) => {
    state.gettingTags = false;
    state.tagList = action.payload;
    return state;
  },

  [GETTING_PRINT_TAGS_FAILED]: (state, action) => {
    state.gettingTags = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_PRINT_FILE]: (state) => {
    state.printFile = {
      getting: true,
      isDownloading: true,
      gettingFileSucceeded: false,
      printFileBlob: {}
    };
    state.isTestDownloadError = false;
    return state;
  },
  [GETTING_PRINT_FILE_SUCCEEDED]: (state, action) => {
    state.printFile = {
      getting: false,
      gettingFileSucceeded: true,
      printFileBlob: action.payload
    };
    state.isTestDownloadError = false;
    return state;
  },
  [GETTING_PRINT_FILE_FAILED]: state => {
    state.printFile = {
      getting: false,
      gettingFileSucceeded: false,
      printFileBlob: {}
    };
    state.isTestDownloadError = true;
    return state;
  },
  [DOWNLOADED_PRINT_FILE]: state => {
    state.printFile = {
      ...state.printFile,
      isDownloading: false,
      gettingFileSucceeded: false,
      printFileBlob: {}
    };
    return state;
  },
  [SET_TEST_DOWNLOAD]: (state, action) => {
    state.isTestDownloadError = action.payload;
    return state;
  },
  [UPDATE_PRINT_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_PRINT_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = {
      ...initialState.filters
    };
    return state;
  }
});
